import { TabProxy } from "encampy";

export async function automateMOLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#Username", { timeout: 10000 });

  // Type in the username
  await tab.type("input#Username", username);

  // Click Next
  await tab.click("button[name='button'][value='next']");

  await tab.waitForNavigation({ timeout: 10000 });

  // Type in the password
  await tab.type("input#Password", password);

  // Click Login
  await tab.click("button[name='button'][value='login']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
